export interface IWindowSize {
  innerWidth: number
  innerHeight: number
}
export const getWindowSize = (): IWindowSize => {
  const { innerWidth, innerHeight } = window
  return { innerWidth, innerHeight }
}
